import { memo } from "react";
import { Text, Button } from "@src/components";
import { DialogModal } from "@src/components/DialogModal";
import { isWeb } from "@src/utils/web-helpers";

interface MonitoringUpgradeDialogProps {
  visible: boolean;
  onClose: () => void;
  onSendRequest: () => void;
}

export const MonitoringUpgradeDialog = memo(({ visible, onClose, onSendRequest }: MonitoringUpgradeDialogProps) => (
  <DialogModal
    visible={visible}
    onClose={onClose}
    title="Request Monitoring Upgrade"
    style={{ width: isWeb ? 500 : undefined }}
  >
    <Text textStyle="xs/regular" color="textMuted" mb="5xl">
      Upgrade to 24/7 ASIAL-accredited monitoring. Our team will contact you shortly to help you get set up.
    </Text>
    <Button label="Send request" variant="primary" variantColor="blue" size="md" onPress={onSendRequest} />
  </DialogModal>
));
